import PropTypes from 'prop-types';
import React from 'react';
import EditorRow from '../EditorRow';
import PillSelectBox from '../PillSelectBox';
import { PrepAreaTooltip } from '../TooltipModals';

function PrepAreaSelect(props) {
  return (
    <EditorRow className={props.className} margin={props.margin}>
      <label htmlFor={props.id}>Prep Area</label>
      <PrepAreaTooltip />
      <PillSelectBox
        id={props.id}
        value={props.value || 'general'}
        onChange={e => props.onChange(e)}
      >
        <option className="select-box__option" value="general">
          Front of House
        </option>
        <option className="select-box__option" value="kitchen">
          Kitchen
        </option>
      </PillSelectBox>
    </EditorRow>
  );
}

PrepAreaSelect.propTypes = {
  value: PropTypes.string.isRequired,
};

export default PrepAreaSelect;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/PrepAreaSelect/index.jsx